<div class="station-selection-component">

  <div class="vertical-flex-content">

    <div class="station-groups">
      <h3 class="title">
        <sc-dictionary-label dictionaryKey="tmc-yard.station-selection-component.ui.station-groups.title"></sc-dictionary-label>
      </h3>
      <app-list [selected]="selection.stationGroup">
        @for (sg of stationGroups; track sg) {
          <app-list-item [model]="sg" (click)="setSelectedStationGroup(sg)">
            <div class="station-name">
              {{ sg.name }}
            </div>
          </app-list-item>
        }
      </app-list>
    </div>

    <div class="station-sets">
      <h3 class="title">
        <sc-dictionary-label dictionaryKey="tmc-yard.station-selection-component.ui.station-sets.title"></sc-dictionary-label>
      </h3>
      @if (selection.stationGroup != null) {
        <app-list [selected]="selection.stationSet" class="">
          @for (stationSet of selection.stationGroup.stationSets; track stationSet) {
            <app-list-item [model]="stationSet" (click)="setSelectedStationSet(stationSet)">
              <div class="station-name">
                {{ stationSet.name }}
              </div>
            </app-list-item>
          }
        </app-list>
      }
    </div>

    <div class="stations">
      <h3 class="title">
        <sc-dictionary-label dictionaryKey="tmc-yard.station-selection-component.ui.stations.title"></sc-dictionary-label>
      </h3>
      @if (selection.stationSet != null && includeStations) {
        <div class="stations-grid">
          @for (station of getStations(selection.stationSet); track station) {
            @if (!station.disabled) {
              <div class="grid-box" matRipple (click)="setSelectedStation(station)">
                @if (isStationSelected(station)) {
                  <div class="selection-marker"></div>
                }
                <div class="content">
                  {{station.name}}
                </div>
                @if (station.used) {
                  <div class="icon"><sc-icon iconClass="fa-truck"></sc-icon></div>
                }
                @if (station.suspended) {
                  <div class="icon"><sc-icon iconClass="fa-pause-circle"></sc-icon></div>
                }
              </div>
            }
            @if (station.disabled) {
              <div class="grid-box disabled">
                <div class="content">{{station.name}}</div>
              </div>
            }
          }
        </div>
      }
    </div>

  </div>
</div>
